export class ServerResponse {
  response: any;
  successMessage: string;
  errorMessage: string;
  errorDetails: string;
}

export class ServerObjResponse {
  response: any;
}

export class ServerAlternativeSuccessResponse {
  body: ServerResponse;
  status: number;
}

export class HttpResponseServer {
  body: ServerResponse;
  headers: {};
  ok: boolean;
  status: number;
  statusText: string;
  type: number;
  url: string;
}
